






















































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import DropArea from "../../components/DropArea.vue";
import { SheetBase, Examinee, Curriculum } from "../../modules/teacher/EntranceSheetEdit"

export interface Data {
  sheet_group_key: string
  tabNo: number
  sheetBase: SheetBase
  examinees: Examinee[]
  curriculums: Curriculum[]
  verify_count_cache: number
  is_exists_approval_sheet: boolean
  errors: string[]
  isNew: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_group_key: "",
      tabNo: 1,
      sheetBase: new SheetBase(),
      examinees: new Array<Examinee>(),
      curriculums: new Array<Curriculum>(),
      verify_count_cache: 0,
      is_exists_approval_sheet: false,
      errors: new Array<string>(),
      isNew: false
    });

    /******************************
     * 名簿テンプレートダウンロード
     ******************************/

    const downloadMeiboTemplate = async () => {

      await http.get(`/api/teacher/entrance_sheet_edit/download_meibo_template/${state.sheet_group_key}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `meibo_entrance_template.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /******************************
     * 名簿アップロードAPI
     ******************************/

    const uploadMeibo = async (file: any) => {
      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("受験者情報を読み込みます。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/entrance_sheet_edit/upload_meibo`, fd).then(response => {
        const examinees = new Array<Examinee>();
        response.data.examinees.forEach((examinee: any) => {
          examinees.push(new Examinee(examinee));
        });
        state.examinees = examinees
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 登録前のデータチェック
     ******************************/

    const validate = () => {
      state.errors = new Array<string>();

      if (state.sheetBase.exec_date === "") {
        state.errors.push("実施日が入力されていません。");
      }
      if (state.sheetBase.name === "") {
        state.errors.push("試験名が入力されていません。");
      }
      if (state.sheetBase.curriculum_id === "") {
        state.errors.push("教科が選択されていません。");
      }
      if(!state.sheetBase.verify_count){
        state.errors.push("採点回数が選択されていません");
      }
      if (state.examinees.length == 0) {
        state.errors.push("受験者情報エクセルが読み込まれていません。");
      }
      const stundentNoCharacters = state.examinees.map(x => x.student_no_character);
      const distinctStudentNoCharacters = Array.from(new Set(stundentNoCharacters));
      if(stundentNoCharacters.length != distinctStudentNoCharacters.length){
        state.errors.push("重複している受験番号が存在します。");
      }

      return state.errors.length == 0;
    };

    /******************************
     * 新規登録API
     ******************************/

    const createClick = async () => {
      if (!validate() || !window.confirm('試験を追加しますか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/entrance_sheet_edit`, {sheet_base: state.sheetBase, examinees: state.examinees}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 更新API
     ******************************/

    const updateClick = async () => {

      // 承認済みのsheetが存在する状態で採点回数を2=>3回に変更する場合、承認済みを未承認に戻すので確認メッセージを表示
      let is_reset_approval_flg: boolean = false;
      if(state.is_exists_approval_sheet && state.verify_count_cache == 2 && state.sheetBase.verify_count == 3){
        if(!window.confirm('承認済みの試験が存在します。採点回数を2回から3回に更新すると、承認済みの試験は未承認に戻ります。よろしいですか？')) {
          return;
        }
        is_reset_approval_flg = true;
      }

      if (!validate() || !window.confirm('試験を更新しますか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/entrance_sheet_edit/update/${state.sheet_group_key}`, {sheet_base: state.sheetBase, examinees: state.examinees, is_reset_approval_flg: is_reset_approval_flg}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 削除API
     ******************************/

    const deleteClick = async () => {
      if(!window.confirm("試験を削除します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/entrance_sheet_edit/${state.sheet_group_key}`).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      state.isNew = context.root.$route.path.indexOf("new") != -1;
      
      if(!state.isNew){
        await http.get(`/api/teacher/entrance_sheet_edit/?sheet_group_key=${state.sheet_group_key}`).then(response => {
          state.sheetBase.name = response.data.sheets[0].name;
          state.sheetBase.curriculum_id = response.data.sheets[0].curriculum_id;
          state.sheetBase.subject_name = response.data.sheets[0].subject_name;
          state.sheetBase.exec_date = moment(response.data.sheets[0].exec_date).format('YYYY-MM-DD');
          state.sheetBase.verify_count = response.data.sheets[0].verify_count;
          state.verify_count_cache = response.data.sheets[0].verify_count;
          state.curriculums = response.data.curriculums.map((x: any) => new Curriculum(x));
          state.sheetBase.is_sort_answer_image_enable = response.data.sheets[0].is_sort_answer_image_enable;
          state.sheetBase.is_mask_student_info = response.data.sheets[0].is_mask_student_info;
          
          response.data.sheets.forEach((sheet: any) => {
            if(sheet.approval_flg){
              state.is_exists_approval_sheet = true;
            }
            sheet.examinees.forEach((examinee: any) => {
              state.examinees.push(new Examinee(examinee));
            });
          });
        })
        .catch(error=>{
          // 後続処理不能のため一覧に戻る
          if(error.response.status == 422){
            alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
          }else{
            alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
          }
          window.history.back();
        });
      }else{
        await http.get(`/api/teacher/entrance_sheet_edit/new`).then(response => {
          state.curriculums = response.data.curriculums.map((x: any) => new Curriculum(x));
        });
      }
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      createClick,
      updateClick,
      deleteClick,
      uploadMeibo,
      downloadMeiboTemplate,
    };
  }
})
